import { routerFrom } from "router";

export const routes = [
  {
    acl: [],
    label: "Accept Manager Invitation",
    name: "manager-invitations.accept",
    path: "/manager-invitations/:invitationId",
  },
];

export const router = routerFrom(routes);
